import React, { useState, useEffect} from 'react';
import { Modal, Badge, Input } from 'antd';
import strings from '../../../../strings';

const CustomVariant = ({ 
  open, 
  onCancel, 
  product, 
  handleNitroVariantSelect,
  handleBlurFactor 
}) => {

    const [ selectedVariants, setSelectedVariants ] = useState({});
    const [ groupedVariants, setGroupedVariants ] = useState({});
    const [ isSelected, setIsSelected ]= useState({});
    const [ user, setUser ] = useState([]);
    const [ variantSearch, setVariantSearch ] = useState("");

    useEffect(()=>{
        const isMerchant = localStorage.getItem("userDetails");
        const merchant = isMerchant && JSON.parse(isMerchant);
        setUser(merchant);
        handleBlurFactor(false);
    }, []);

    useEffect(()=>{
        const groupedVariants = {};
        const selectVariantsObj = {};
        product.variants.forEach(variant => {
            if (groupedVariants[variant.type]) {
                groupedVariants[variant.type].push(variant);
            } else {
                selectVariantsObj[variant.type] = [];
                groupedVariants[variant.type] = [variant];
            }
        });
        setSelectedVariants(selectVariantsObj);
        setGroupedVariants(groupedVariants);
    }, [product]);

    const displayVariants = () => {
        const variants = groupedVariants;
        const keys = Object.keys(variants);
        return keys.map(key => {
          // Filter variants by search
          const filteredVariants = variants[key].filter(variant => {
            const search = variantSearch.trim().toLowerCase();
            if (!search) return true;
            return (
              (variant.value && variant.value.toLowerCase().includes(search)) ||
              (variant.sku && variant.sku.toLowerCase().includes(search))
            );
          });
          return (
            <div key={key}>
              <span className="type">{`${key}:`}</span>
              <div className="variant-wrapper">
                {filteredVariants.length === 0 && (
                  <span style={{ color: '#999', fontStyle: 'italic' }}>No variants found</span>
                )}
                {filteredVariants.map(variant => {
                  return (
                    <Badge
                      key={variant.id}
                      className={
                        isSelected?.id === variant.id
                          ? strings.variantSelected
                          : strings.variant
                      }
                      onClick={() => {
                        selectVariant(variant, key);
                      }}
                    >
                      {/* Image preview */}
                      {variant.image && (
                        <img
                          src={variant.image}
                          alt={variant.value}
                          style={{ width: 32, height: 32, objectFit: 'cover', marginRight: 8, borderRadius: 4, border: '1px solid #eee', background: '#fff' }}
                        />
                      )}
                      <span style={{ paddingRight: "10px" }}>{variant.value}</span>
                      <span style={{ paddingRight: "10px" }}>-</span>
                      <span>
                        {user && user.currency}
                        {product.tax_rate
                          ? (
                              (product.tax_rate / 100) * variant.price +
                              parseFloat(variant.price)
                            ).toFixed(2)
                          : variant.price}
                      </span>
                    </Badge>
                  );
                })}
              </div>
            </div>
          );
        });
      };

      const selectVariant = (variant, key) => {
        // setQuantity(1)
        const keys = Object.keys(selectedVariants);
        let check = false;
        keys.forEach(selectedKey => {
          if (selectedVariants[selectedKey].length > 0 && key !== selectedKey) {
            if (selectedVariants[selectedKey][0].price !== variant.price) {
              check = true;
            }
          }
        });
        if (check) {
          Modal.warning({
            title: strings.thePreviousVariantSelectionNotAvailable,
          });
          return;
        }
        selectedVariants[key] = [variant];

        setIsSelected(variant)
        setSelectedVariants(selectedVariants)
        // console.log(selectedVariants, variant);
        handleNitroVariantSelect(product, variant);
        onCancel();
    };

  return (
    <>
        <Modal
            title={`${product.name} ${product.price}`}
            cancelText={strings.cancel}
            footer={null}
            onCancel={onCancel}
            destoryOnClose
            open={open}
        >
            <div className="variants">
              <span>Select Variants:</span>
              {/* Search filter for variants */}
              <div style={{ margin: '12px 0' }}>
                <Input.Search
                  allowClear
                  placeholder="Search variant by name or SKU"
                  value={variantSearch}
                  onChange={e => setVariantSearch(e.target.value)}
                  style={{ width: '100%' }}
                  size="small"
                />
              </div>
              <div>{displayVariants()}</div>
            </div>
        </Modal>
    </>
  ) 
}

export default CustomVariant